import { type Common } from './common.js';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async generateSsoJwt(): Promise<{ token: string; redirectUrl: string }> {
    const url = this.common.constructPath(`/mindtickle/generate-sso-jwt`);
    return await this.common.postJSON(url, {});
  }
}
